module.exports = "/_next/static/images/IlloUseCaseActivateCustomerDataDefault-f60f6633290dddf4a126645b44cba894.png";